import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import * as accountTypes from '@account/store/types'
import api from '@board/api'

@Component({
    computed: mapGetters({
        User: accountTypes.USER,
    })
})
export default class CommentWrite extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Object }) item!: article.ArticleComment
    @Prop({type: Boolean, default: false }) show!: boolean
    @Prop({type: Number}) articleId!: number
    @Prop({type: Number, default: 0}) commentId!: number
    @Prop({type: Number, default: 0}) mode!: number  // 등록 0, 수정 1, 답글 2 

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    mComment: string = ""

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    // 댓글, 답글 등록
    async createComment() {
        if (this.mComment.length == 0) {
            await(window as any).alertAsync(this.$t('M_BB_CommentIsNull').toString());
            return;
        }

        api.article.createComment(<article.CreateComment>{
            createdUser: {
                deptName: this.User.titleName,
                deptName_En: this.User.titleNameEn,
                userCode: this.User.id,
                userJobTitle: this.User.deptName,
                userJobTitle_En: this.User.deptNameEn,
                userName: this.User.displayName,
                userName_En: this.User.displayNameEng
            },
            replyTo: this.mode == 0 ? null : this.item.commentId,
            articleId: this.articleId,
            content: this.mComment
        }).then(res => {
            this.mComment = "";
            this.$emit('loadComment', this.articleId)
        })
    }

    // 내 댓글 수정
    updateComment() {
        api.article.createComment(<article.CreateComment>{
            createdUser: {
                deptName: this.User.titleName,
                deptName_En: this.User.titleNameEn,
                userCode: this.User.id,
                userMail: this.User.email,
                userDept: this.User.deptCode,
                userPhone: this.User.officeTel,
                userJobTitle: this.User.deptName,
                userJobTitle_En: this.User.deptNameEn,
                userName: this.User.displayName,
                userName_En: this.User.displayNameEng
            },
            replyTo: this.item.replyTo,
            articleId: this.articleId,
            content: this.mComment,
            commentId: this.item.commentId
        }).then(res => {                
            this.$emit('loadComment', this.articleId)
        })  
    }

    @Watch('mode')
    onChangedMode(newVal: number) {
        if (this.mode == 1) {
            this.mComment = this.item.content
        } else {
            this.mComment = ''
        }
    }
}